import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cms-home',
  templateUrl: './cms-home.component.html',
  styleUrls: ['./cms-home.component.scss']
})
export class CmsHomeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
